// File: components/eventsSectionsComponents/EventsWorkWithLeadership.jsx

import React from "react";
import "./EventsWorkWithLeadership.css";
import { useNavigate } from "react-router-dom";

import leadershipImage from "../../Assets/images/amplehouseentrance.jpg";

export default function EventsWorkWithLeadership() {

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (

    <section className="events-work-section">

      <div className="events-work-container">

        {/* Header */}
        <div className="events-work-header">

          <h2>
            Working with Ample Events
          </h2>

          <p>
            Gather leaders and ignite dialogue at premier events.
          </p>

        </div>

        {/* Main Content */}
        <div className="events-work-content-wrapper">

          {/* Left Image */}
          <div className="events-work-image-wrapper">

            <img
              src={leadershipImage}
              alt="AMPLE Leadership Events"
              className="events-work-image"
            />

          </div>

          {/* Right Content */}
          <div className="events-work-content">

            <p>
              Partner with AMPLE HOUSE to host and
              participate in events that engage, inspire,
              and transform visionary leaders.
            </p>

            <button
              className="events-work-btn"
              onClick={handleNavigate}
            >
              Partner With US
            </button>

          </div>

        </div>

      </div>

    </section>

  );
}